@if (marketplaceAuction) {
  <div class="card card-auction-item">
    @if (marketplaceAuction.media && marketplaceAuction.media[0] && marketplaceAuction.media[0].url1x) {
      <div [lazyLoad]="marketplaceAuction.media[0].url1x" class="img-container">
        <div class="labels-container">
          @if (marketplaceAuction.status !== AuctionStatus.Active) {
            <div class="img-label-red status-label">
              {{ statusDisplayName(marketplaceAuction.status) | transloco }}
            </div>
          }
          @if (marketplaceAuction.label && marketplaceAuction.status === 0) {
            <div class="img-label-primary item-label">
              {{ marketplaceAuction.label }}
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="img-container no-img-container"></div>
    }
    <div class="auction-board-item-details-container">
      <div>
        @if (marketplaceAuction.title) {
          <h2 class="mb-0 dot auction-title">{{ marketplaceAuction.title }}</h2>
        }
        <ul class="card-top-bar">
          @if (isValueTruthyOrZero(marketplaceAuction.type)) {
            <li class="font-weight-bold">
              {{ getAuctionTypeName(marketplaceAuction.type) | transloco }}
            </li>
          }
          @if (isValueTruthyOrZero(marketplaceAuction.type)) {
            <li class="dot-break"></li>
          }
          @if (marketplaceAuction.inserted) {
            <li>{{ marketplaceAuction.inserted | date: 'mediumDate' }}</li>
          }
          @if (isValueTruthyOrZero(marketplaceAuction.delivery_method)) {
            <li class="dot-break"></li>
          }
          @if (isValueTruthyOrZero(marketplaceAuction.delivery_method)) {
            <li>
              {{ getDeliveryTypeName(marketplaceAuction.delivery_method) | transloco }}
            </li>
          }
        </ul>
        @if (marketplaceAuction.description) {
          <div class="item-description" [innerHTML]="getTextWithLimit(marketplaceAuction.description)"></div>
        }
      </div>
      <div class="card-footer">
        @if (
          marketplaceAuction.price &&
          (marketplaceAuction.price_type === priceTypes.AskingPrice ||
            marketplaceAuction.price_type === priceTypes.PricePerUnit)
        ) {
          <div class="font-weight-bold card-price">
            <span>{{ marketplaceAuction.price | currency: 'EUR' }}</span>
            @if (marketplaceAuction.price_type === priceTypes.PricePerUnit) {
              <span class="price-unit">
                / {{ (priceUnitDisplayValues[marketplaceAuction.unit] | transloco) || '' }}</span
              >
            }
          </div>
        } @else {
          <div class="font-weight-bold card-price">
            {{ priceTypesDisplayValues[marketplaceAuction.price_type] | transloco }}
          </div>
        }
        <div>
          <a [routerLink]="['/marketplace', marketplaceAuction.id]" class="btn btn-card">
            {{ 'global.open' | transloco }}
          </a>
        </div>
      </div>
    </div>
  </div>
}
